import { Columns } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Box, Typography } from "@aviary";
import { Container } from "@aviary/layouts";
import { l } from "@login/locales/i18n";
import FsLogoLeafGreenerySVGComponent from "@shared/assets/FsLogoLeafGreenery";
import BuildersLoginSVGComponent from "@shared/assets/svg/graphics/BuildersLogin";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
// TODO: Reinvestigate the location of this component to move SSO Login to the unauthenticated app
// eslint-disable-next-line @fullscript/cross-reference
import { CountrySelect } from "@unauthenticated/signupSignin/components/CountrySelect/CountrySelect";

import { SSOLoginForm } from "./SSOLoginForm";

import * as styles from "./SSOLogin.styles";

const SSOLogin = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const renderCountrySelector = (isWithTitle: boolean) => {
    if (isWithTitle) {
      return (
        <div data-testid="header-flags">
          <CountrySelect slug="/sso_login" />
        </div>
      );
    }

    return null;
  };

  return (
    <Container css={styles.ssoContainer}>
      <Columns>
        {!tablet.lessThan && (
          <Columns.Column columnWidth={5}>
            <Typography css={styles.builderText} type="h1">
              {t(l.login.Builders)}
            </Typography>
            <BuildersLoginSVGComponent />
          </Columns.Column>
        )}
        <Columns.Column columnWidth={6} phoneWidth={12} customCss={styles.rightColumn}>
          <div>
            <div css={styles.formMetaDS4}>
              <Typography css={styles.titleText} type="h2">
                <FsLogoLeafGreenerySVGComponent /> {t(l.login.Fullscript)}
              </Typography>
              {renderCountrySelector(true)}
            </div>
            <Box padding="none" layoutStyles={styles.ds4FormBox}>
              <Typography css={styles.enterEmailText} type="h2">
                {t(l.login.EnterEmail)}
              </Typography>
              <div css={styles.form}>
                <SSOLoginForm />
                <a href="/login?bypass_cookie='true" css={styles.loginLink}>
                  {t(l.login.BackToUserLogin)}
                </a>
              </div>
            </Box>
            {renderCountrySelector(false)}
          </div>
        </Columns.Column>
      </Columns>
    </Container>
  );
};

export { SSOLogin };
